var render = function render(){var _vm=this,_c=_vm._self._c;return _c('money',_vm._b({staticClass:"form-control",attrs:{"id":_vm.name,"maxlength":_vm.maxLength,"name":_vm.name},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'money',_vm.money,false))
}
var staticRenderFns = []

export { render, staticRenderFns }